import * as React from 'react';

import { CardStatus, PaymentMethodProps } from './interface';
import { PaymentMethodLine } from './payment-method-line';
import { PaymentMethodTile } from './payment-method-tile';
import { getExpiryDateString, getPaymentMethodMenuItems } from './utils';


export const PaymentMethod = (props: PaymentMethodProps): JSX.Element => {
  const {
    card,
    isPrimary,
    isBackup,
    isSubscription,
    isLine,
    setSubscriptionCard,
  } = props;
  const menuItems = getPaymentMethodMenuItems(props);
  const isExpired =  card.status === CardStatus.expired;
  const onCardClick = React.useCallback(() => {
    if (!isSubscription && setSubscriptionCard && !isExpired) {
      setSubscriptionCard(card.id);
    }
  }, [isSubscription, setSubscriptionCard, isExpired, card.id]);
  const expiryString = getExpiryDateString(card.expiryMonth, card.expiryYear);
  const View = isLine ? PaymentMethodLine : PaymentMethodTile;

  return (
    <View
      isBackup={isBackup}
      isPrimary={isPrimary}
      isSubscription={isSubscription}
      expiryString={expiryString}
      onCardClick={onCardClick}
      cardLast4={card.last4}
      cardType={card.type}
      menuItems={menuItems}
    />
  );
};


